<template>
  <Select
    v-model="majorValue"
    size="large"
    :options="options"
    placeholder="请选择专业"
    @change="onChange"
    allowClear
    :loading="loading"
  ></Select>
</template>
<script setup lang="ts">
import { Select } from 'ant-design-vue'
import { ref, watch } from 'vue'
import { getFacultyList } from '@/api/web'

type Props = {
  facultyName?: string
}

const props = withDefaults(defineProps<Props>(), {})

const majorValue = ref()
const options = ref<{ label: string; value: string }[]>()

watch(
  () => props.facultyName,
  (val) => {
    if (val) {
      loadData()
    } else {
      options.value = undefined
      majorValue.value = undefined
      emit('input', undefined)
    }
  }
)

const loading = ref(false)
function loadData() {
  loading.value = true
  getFacultyList({
    name: props.facultyName,
  })
    .then((response) => {
      const data = response.data[0]
      if (data) {
        options.value = data.major.split(',').map((i) => ({
          label: i,
          value: i,
        }))
      }
    })
    .finally(() => {
      loading.value = false
    })
}

const emit = defineEmits(['input'])
function onChange(val: string) {
  emit('input', val)
}
</script>
<style lang="less" scoped></style>
